module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/wine-822fc69c3ac8a001738f391b197c14de.svg";